export const TZ_DISPLAY_MAP = {
  "Etc/GMT+12" : "(UTC-12:00) International Date Line West",
  "Etc/GMT+11" : "(UTC-11:00) Coordinated Universal Time-11",
  "Etc/GMT+10" : "(UTC-10:00) Hawaii",
  "America/Anchorage" : "(UTC-09:00/UTC-08:00) Alaska",
  "America/Santa_Isabel" : "(UTC-08:00/UTC-07:00) Baja California",
  "PST8PDT" : "(UTC-08:00/UTC-07:00) Pacific Time (US & Canada)",
  "Etc/GMT+7" : "(UTC-07:00) Arizona",
  "America/Chihuahua" : "(UTC-07:00/UTC-06:00) Chihuahua, La Paz, Mazatlan",
  "MST7MDT" : "(UTC-07:00/UTC-06:00) Mountain Time (US & Canada)",
  "Etc/GMT+6" : "(UTC-06:00) Central America",
  "CST6CDT" : "(UTC-06:00/UTC-05:00) Central Time (US & Canada)",
  "America/Mexico_City" : "(UTC-06:00/UTC-05:00) Guadalajara, Mexico City, Monterrey",
  "America/Regina" : "(UTC-06:00) Saskatchewan",
  "Etc/GMT+5" : "(UTC-05:00) Bogota, Lima, Quito",
  "EST5EDT" : "(UTC-05:00/UTC-04:00) Eastern Time (US & Canada)",
  "America/Indianapolis" : "(UTC-05:00/UTC-04:00) Indiana (East)",
  "America/Caracas" : "(UTC-04:30) Caracas",
  "America/Asuncion" : "(UTC-04:00/UTC-03:00) Asuncion",
  "America/Halifax" : "(UTC-04:00/UTC-03:00) Atlantic Time (Canada)",
  "America/Cuiaba" : "(UTC-04:00/UTC-03:00) Cuiaba",
  "Etc/GMT+4" : "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  "America/Santiago" : "(UTC-04:00/UTC-03:00) Santiago",
  "America/St_Johns" : "(UTC-03:30/UTC-02:30) Newfoundland",
  "America/Sao_Paulo" : "(UTC-03:00) Brasilia",
  "America/Buenos_Aires" : "(UTC-03:00) Buenos Aires",
  "Etc/GMT+3" : "(UTC-03:00) Cayenne, Fortaleza",
  "America/Godthab" : "(UTC-03:00/UTC-03:00) Greenland",
  "America/Montevideo" : "(UTC-03:00) Montevideo",
  "America/Bahia" : "(UTC-03:00) Salvador",
  "Etc/GMT+2" : "(UTC-02:00) Coordinated Universal Time-02",
  "Atlantic/Azores" : "(UTC-01:00/UTC+00:00) Azores",
  "Etc/GMT+1" : "(UTC-01:00) Cape Verde Is.",
  "Africa/Casablanca" : "(UTC+01:00) Casablanca",
  "Etc/GMT" : "(UTC+00:00) Coordinated Universal Time",
  "Europe/London" : "(UTC+00:00/UTC+01:00) Dublin, Edinburgh, Lisbon, London",
  "Atlantic/Reykjavik" : "(UTC+00:00) Monrovia, Reykjavik",
  "Europe/Berlin" : "(UTC+01:00/UTC+02:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  "Europe/Budapest" : "(UTC+01:00/UTC+02:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  "Europe/Paris" : "(UTC+01:00/UTC+02:00) Brussels, Copenhagen, Madrid, Paris",
  "Europe/Warsaw" : "(UTC+01:00/UTC+02:00) Sarajevo, Skopje, Warsaw, Zagreb",
  "Etc/GMT-1" : "(UTC+01:00) West Central Africa",
  "Africa/Windhoek" : "(UTC+02:00) Windhoek",
  "Asia/Amman" : "(UTC+02:00/UTC+03:00) Amman",
  "Europe/Bucharest" : "(UTC+02:00/UTC+03:00) Athens, Bucharest",
  "Asia/Beirut" : "(UTC+02:00/UTC+03:00) Beirut",
  "Africa/Cairo" : "(UTC+02:00) Cairo",
  "Asia/Damascus" : "(UTC+02:00/UTC+03:00) Damascus",
  "Etc/GMT-2" : "(UTC+02:00) Harare, Pretoria",
  "Europe/Kiev" : "(UTC+02:00/UTC+03:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  "Asia/Jerusalem" : "(UTC+02:00/UTC+03:00) Jerusalem",
  "Asia/Nicosia" : "(UTC+02:00/UTC+03:00) Nicosia",
  "Europe/Kaliningrad" : "(UTC+02:00) Kaliningrad, Minsk",
  "Europe/Istanbul" : "(UTC+03:00) Istanbul",
  "Asia/Baghdad" : "(UTC+03:00) Baghdad",
  "Asia/Riyadh" : "(UTC+03:00) Kuwait, Riyadh",
  "Etc/GMT-3" : "(UTC+03:00) Nairobi",
  "Asia/Tehran" : "(UTC+03:30/UTC+04:30) Tehran",
  "Etc/GMT-4" : "(UTC+04:00) Abu Dhabi, Muscat",
  "Asia/Baku" : "(UTC+04:00) Baku",
  "Europe/Moscow" : "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
  "Indian/Mauritius" : "(UTC+04:00) Port Louis",
  "Asia/Tbilisi" : "(UTC+04:00) Tbilisi",
  "Asia/Yerevan" : "(UTC+04:00) Yerevan",
  "Asia/Kabul" : "(UTC+04:30) Kabul",
  "Asia/Karachi" : "(UTC+05:00) Islamabad, Karachi",
  "Etc/GMT-5" : "(UTC+05:00) Tashkent",
  "Asia/Calcutta" : "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  "Asia/Colombo" : "(UTC+05:30) Sri Jayawardenepura",
  "Asia/Katmandu" : "(UTC+05:45) Kathmandu",
  "Etc/GMT-6" : "(UTC+06:00) Astana",
  "Asia/Dhaka" : "(UTC+06:00) Dhaka",
  "Asia/Yekaterinburg" : "(UTC+06:00) Ekaterinburg",
  "Asia/Rangoon" : "(UTC+06:30) Yangon (Rangoon)",
  "Etc/GMT-7" : "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  "Asia/Novosibirsk" : "(UTC+07:00) Novosibirsk",
  "Asia/Shanghai" : "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  "Asia/Krasnoyarsk" : "(UTC+08:00) Krasnoyarsk",
  "Etc/GMT-8" : "(UTC+08:00) Kuala Lumpur, Singapore",
  "Australia/Perth" : "(UTC+08:00) Perth",
  "Asia/Taipei" : "(UTC+08:00) Taipei",
  "Asia/Ulaanbaatar" : "(UTC+08:00) Ulaanbaatar",
  "Asia/Irkutsk" : "(UTC+09:00) Irkutsk",
  "Etc/GMT-9" : "(UTC+09:00) Osaka, Sapporo, Tokyo",
  "Asia/Seoul" : "(UTC+09:00) Seoul",
  "Asia/Yakutsk" : "(UTC+09:00) Yakutsk",
  "Australia/Adelaide" : "(UTC+09:30/UTC+10:30) Adelaide",
  "Australia/Darwin" : "(UTC+09:30) Darwin",
  "Australia/Brisbane" : "(UTC+10:00) Brisbane",
  "Australia/Sydney" : "(UTC+10:00/UTC+11:00) Canberra, Melbourne, Sydney",
  "Etc/GMT-10" : "(UTC+10:00) Guam, Port Moresby",
  "Australia/Hobart" : "(UTC+10:00/UTC+11:00) Hobart",
  "Pacific/Guadalcanal" : "(UTC+11:00) Solomon Is., New Caledonia",
  "Asia/Vladivostok" : "(UTC+11:00) Vladivostok",
  "Pacific/Auckland" : "(UTC+12:00/UTC+13:00) Auckland, Wellington",
  "Etc/GMT-12" : "(UTC+12:00) Coordinated Universal Time+12",
  "Pacific/Fiji" : "(UTC+12:00/UTC+13:00) Fiji",
  "Asia/Magadan" : "(UTC+12:00) Magadan",
  "Etc/GMT-13" : "(UTC+13:00) Nuku'alofa",
  "Pacific/Apia" : "(UTC+13:00/UTC+14:00) Samoa",
};
